export default __webpack_public_path__ + "static/media/img-0476-bulgaria-half-face.705931e8.png";